module.exports = __webpack_public_path__ + "00c055d8928e2bb6e4f83b9d3a68c0b0.png";